import React, { useState, useEffect } from 'react';
import { useLoading } from '../context/LoadingContext';
import OrderModal from './OrderModal';
import TableFilter from './TableFilter';
import InvoicePreviewModal from './InvoicePreviewModal';
import { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FaEdit, FaEye } from 'react-icons/fa';
import { getOrderPaymentDetails, updateRazorpayOrder } from '../service/OrderPaymentService';
// import { order } from '../../../server/product-api/database';

const OrdersTable = ({ status }) => {
  const otpRefs = useRef([]);
  const { showLoading, hideLoading } = useLoading();
  const [orders, setOrders] = useState([]);
  const [orderPaymentDetails, setOrderPaymentDetails] = useState({});
  const invoiceRef = useRef();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [success, setSuccess] = useState(null);
  const [oldOrderId, setOldOrderId] = useState('');
  const [newOrderId, setNewOrderId] = useState('');
  const [otp, setOtp] = useState(Array(6).fill(''));
  const [isEditing, setIsEditing] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 20
  });

  const [filters, setFilters] = useState({
    searchTerm: '',
    dateRange: '',
    minAmount: '',
    maxAmount: ''
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const pageSizeOptions = [10, 20, 50, 100];

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleApplyFilters = async () => {
    const queryParams = new URLSearchParams();
    
    // Add page and limit
    queryParams.append('page', '1');
    queryParams.append('limit', pagination.itemsPerPage.toString());
    
    // Add search term (order ID)
    if (filters.searchTerm) {
      queryParams.append('orderId', filters.searchTerm);
    }
    
    // Add amount range
    if (filters.minAmount) {
      queryParams.append('minAmount', filters.minAmount);
    }
    if (filters.maxAmount) {
      queryParams.append('maxAmount', filters.maxAmount);
    }
    
    // Add date range only if selected
    if (filters.dateRange) {
      const now = new Date();
      let startDate = new Date();
      let endDate = new Date();

      switch (filters.dateRange) {
        case 'today':
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'week':
          startDate.setDate(now.getDate() - 7);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'month':
          startDate.setMonth(now.getMonth() - 1);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          break;
        default:
          // Don't add date parameters if no valid range selected
          break;
      }

      if (filters.dateRange !== '') {
        queryParams.append('startDate', startDate.toISOString());
        queryParams.append('endDate', endDate.toISOString());
      }
    }

    fetchOrders(1, queryParams.toString());
  };

  const fetchOrderPaymentDetails = async (orders) => {
    console.log("ssssssssss", orders)
    try {
      const token = localStorage.getItem('token');
      const paymentDetailsPromises = orders.map(async (order) => {
        try {
          const paymentDetails = await getOrderPaymentDetails(order.razorpay_order_id, token);
          
          return { orderId: order.razorpay_order_id, paymentDetails };
        } catch (error) {
          console.error(`Failed to fetch payment details for order ${order.razorpay_order_id}:`, error);
          return { orderId: order.razorpay_order_id, paymentDetails: null };
        }
      });

      const paymentDetailsResults = await Promise.all(paymentDetailsPromises);
      
      // Convert array to object for easier lookup
      const paymentDetailsMap = {};
      paymentDetailsResults.forEach(({ orderId, paymentDetails }) => {
        paymentDetailsMap[orderId] = paymentDetails;
      });
      
      setOrderPaymentDetails(paymentDetailsMap);
    } catch (error) {
      console.error('Failed to fetch payment details:', error);
    }
  };
 console.log("order details", orderPaymentDetails)
  const fetchOrders = async (page, queryString = '') => {
    try {
      showLoading();
      const token = localStorage.getItem('token');
      const baseUrl = `${process.env.REACT_APP_API_BASE_URL}/api/orders/status/${status}`;
      
      // If no queryString provided, create default one with just page and limit
      const finalQueryString = queryString || new URLSearchParams({
        page: page.toString(),
        limit: pagination.itemsPerPage.toString()
      }).toString();

      const response = await fetch(
        `${baseUrl}?${finalQueryString}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': '*/*'
          }
        }
      );
      
      if (!response.ok) {
        throw new Error('Failed to fetch orders');
      }
      
      const data = await response.json();
      setOrders(data.orders);
      setPagination(data.pagination);
      
      // Fetch payment details for all orders
      if (data.orders && data.orders.length > 0) {
        await fetchOrderPaymentDetails(data.orders);
      }
    } catch (error) {
      console.error('Failed to fetch orders:', error);
    } finally {
      hideLoading();
    }
  };

  const handlePageSizeChange = (newSize) => {
    setPagination(prev => ({
      ...prev,
      itemsPerPage: newSize,
      currentPage: 1
    }));
    fetchOrders(1, new URLSearchParams({
      page: 1,
      limit: newSize,
      ...(filters.searchTerm && { search: filters.searchTerm }),
      ...(filters.dateRange && { dateRange: filters.dateRange }),
      ...(filters.minAmount && { minAmount: filters.minAmount }),
      ...(filters.maxAmount && { maxAmount: filters.maxAmount })
    }).toString());
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    
    // Only allow numbers
    if (!/^[0-9]?$/.test(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    
    // Auto-focus next input when number is entered
    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    // Handle backspace to move to previous input and clear current
    if (e.key === 'Backspace') {
      e.preventDefault();
      const newOtp = [...otp];
      
      if (otp[index]) {
        // If current input has value, clear it
        newOtp[index] = '';
        setOtp(newOtp);
      } else if (index > 0) {
        // If current input is empty, move to previous and clear it
        newOtp[index - 1] = '';
        setOtp(newOtp);
        otpRefs.current[index - 1]?.focus();
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      otpRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowRight' && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  useEffect(() => {
    fetchOrders(1);
    return () => {
      // Cleanup loading state when component unmounts
      hideLoading();
    };
  }, [status]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR'
    }).format(amount);
  };

  const getStatusColor = (status) => {
    const colors = {
      PENDING: 'bg-yellow-100 text-yellow-800',
      CONFIRMED: 'bg-blue-100 text-blue-800',
      SHIPPED: 'bg-purple-100 text-purple-800',
      OUT_FOR_DELIVERY: 'bg-orange-100 text-orange-800',
      DELIVERED: 'bg-green-100 text-green-800',
      CANCELLED: 'bg-red-100 text-red-800',
      RETURNED: 'bg-gray-100 text-gray-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const getMonthCode = (date) => {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    return months[date.getMonth()];
  };

  const getCurrentYearCode = (dateValue) => {
    const date = dateValue ? new Date(dateValue) : new Date();
    // Return last 2 digits of current year (e.g., 26 for 2026)
    return String(date.getFullYear()).slice(-2);
  };

  const formatInvoiceNumber = (order) => {
    if (!order) return '';
    
    const createdAtDate = order.createdAt ? new Date(order.createdAt) : new Date();
    // Use actual calendar month from order date
    const monthCode = getMonthCode(createdAtDate);
    // Use actual calendar year
    const yearCode = getCurrentYearCode(createdAtDate);
    const razorpayId = String(order.razorpay_order_id || '');
    const isCash = order.payment_type === 'CASH' || razorpayId.startsWith('CASH_RAZORPAY') || razorpayId.toUpperCase().includes('CASH');

    if (order.invoice_number) {
      const padded = String(order.invoice_number).padStart(5, '0');
      return `${monthCode}${yearCode}-${padded}`;
    }
    
    // Fallback to old logic
    const digits = razorpayId.replace(/\D/g, '');
    const padded = digits ? digits.slice(-5).padStart(5, '0') : '00000';
    return `${monthCode}${yearCode}-${padded}`;
  };

  const handleStatusUpdate = () => {
    fetchOrders(pagination.currentPage);
  };

  const handleDownloadPDF = async () => {
    const element = invoiceRef.current;
    if (!element || !selectedOrder) return;

    const invoiceNumber = formatInvoiceNumber(selectedOrder);

    // Save original styles
    const originalHeight = element.style.maxHeight;
    const originalOverflow = element.style.overflow;

    // Expand the container so the whole invoice is rendered
    element.style.maxHeight = 'none';
    element.style.overflow = 'visible';

    // Give browser a moment to reflow
    await new Promise((resolve) => setTimeout(resolve, 200));

    // Render to canvas
    const canvas = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });

    // Create PDF
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Convert between canvas px and PDF mm
    const pxPerMm = canvas.width / pdfWidth;
    const pageHeightPx = Math.floor(pdfHeight * pxPerMm);

    // Slice canvas into pages
    let remainingHeight = canvas.height;
    let position = 0;
    let pageIndex = 0;

    while (remainingHeight > 0) {
      const sliceHeight = Math.min(pageHeightPx, remainingHeight);

      // Create a temporary canvas for this page slice
      const pageCanvas = document.createElement('canvas');
      pageCanvas.width = canvas.width;
      pageCanvas.height = sliceHeight;
      const ctx = pageCanvas.getContext('2d');

      // White background to avoid transparency issues
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

      // Draw the slice from the full canvas
      ctx.drawImage(canvas, 0, position, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);

      const imgData = pageCanvas.toDataURL('image/png');

      // Height in mm for this slice
      const imgHeightMm = sliceHeight / pxPerMm;

      if (pageIndex > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, imgHeightMm);

      position += sliceHeight;
      remainingHeight -= sliceHeight;
      pageIndex++;
    }

    // Save file
    pdf.save(`invoice-${invoiceNumber || selectedOrder?.razorpay_order_id || 'pgm'}.pdf`);

    // Restore original styles
    element.style.maxHeight = originalHeight;
    element.style.overflow = originalOverflow;
  };
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Orders — {status}</h2>
          <p className="text-md text-gray-500">
            {pagination.totalItems ?? 0} orders · Page {pagination.currentPage} of {pagination.totalPages ?? 0}
          </p>
        </div>

        <div className="flex items-center gap-3 w-full sm:w-auto">
          <TableFilter
            filters={filters}
            onFilterChange={handleFilterChange}
            onApplyFilters={handleApplyFilters}
          />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow ring-1 ring-black ring-opacity-5 overflow-hidden">
        
          <div className="hidden sm:block">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order ID</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Items</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dates</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-100">
            {orders.length === 0 ? (
              <tr>
                <td colSpan="7" className="px-6 py-8 text-center text-md text-gray-500">
                  No orders found
                </td>
              </tr>
            ) : (
              orders.map((order) => {
                const paymentDetails = orderPaymentDetails[order.razorpay_order_id];
                const isPaymentSuccess = paymentDetails?.success === true;
                const rowClassName = isPaymentSuccess 
                  ? "bg-green-50 hover:bg-green-100 border-l-4 border-green-500" 
                  : "hover:bg-gray-50";
                
                return (
                  <tr key={order.id} className={rowClassName}>
                    <td className="px-6 py-4 whitespace-nowrap text-md font-medium text-gray-900">
                      {order.razorpay_order_id}
                      {isPaymentSuccess && (
                        <span className="ml-2 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          ✓ Paid
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-md text-gray-600">
                      <div className="font-medium text-gray-900">
                        {order.other_info?.shipping?.name || order.other_info?.customerName || '—'}
                      </div>
                      {order.other_info?.shopInfo?.shopName && (
                        <div className="text-xs text-emerald-700 font-semibold flex items-center gap-1 mt-0.5">
                          <span>🏪 {order.other_info.shopInfo.shopName}</span>
                          {order.other_info.shopInfo.shopGst && (
                            <span className="text-gray-400 font-mono text-[10px]">({order.other_info.shopInfo.shopGst})</span>
                          )}
                        </div>
                      )}
                      {!order.other_info?.shopInfo?.shopName && order.other_info?.placedByDistributorId && (
                        <div className="text-xs text-orange-600 font-medium mt-0.5">
                          Distributor Shop: {order.other_info.placedByDistributorId.slice(0, 8)}...
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-md text-gray-600">{order.items?.length ?? 0} items</td>
                    <td className="px-6 py-4 whitespace-nowrap text-md text-right text-gray-800">{formatCurrency(order.totalAmount)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(order.status)}`}>
                        {order.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-md text-gray-500">
                      <div className="flex flex-col">
                        <span>Created: {formatDate(order.createdAt)}</span>
                        <span className="text-xs text-gray-400">Updated: {formatDate(order.updatedAt)}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-md">
                      <div className="flex items-center justify-center space-x-2">
                        {order.status === 'PENDING' && <button
                          onClick={() => { 
                            setIsEditing(true); 
                            setSelectedOrder(order);
                            setOldOrderId(order.razorpay_order_id);
                            setNewOrderId('');
                            setOtp(Array(6).fill(''));
                            setError('');
                            setSuccess('');
                          }}
                          className="inline-flex items-center px-2 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                          aria-label={`Preview order ${order.razorpay_order_id}`}
                          title="Preview order"
                        >
                          <FaEdit />
                        </button>}

                        <button
                          onClick={() => handleViewDetails(order)}
                          className="inline-flex items-center px-2 py-1 border border-gray-200 rounded-md text-indigo-600 hover:bg-indigo-50"
                          aria-label={`View details for ${order.razorpay_order_id}`}
                          title="View details"
                        >
                          <FaEye />
                        </button>

                        <button
                          onClick={() => { setIsPreviewOpen(true); setSelectedOrder(order); }}
                          className="inline-flex items-center px-2 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                          aria-label={`Download invoice for ${order.razorpay_order_id}`}
                          title="Download invoice"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v12m0 0l4-4m-4 4-4-4M21 21H3" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile/card view */}
        <div className="sm:hidden">
          <div className="divide-y divide-gray-100">
            {orders.length === 0 ? (
              <div className="px-4 py-6 text-center text-md text-gray-500">No orders found</div>
            ) : (
              orders.map((order) => {
                const paymentDetails = orderPaymentDetails[order.razorpay_order_id];
                const isPaymentSuccess = paymentDetails?.success === true;
                const cardClassName = isPaymentSuccess 
                  ? "px-4 py-4 bg-green-50 border-l-4 border-green-500" 
                  : "px-4 py-4";
                
                return (
                  <div key={order.id} className={cardClassName}>
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <p className="text-md font-medium text-gray-900 truncate">{order.razorpay_order_id}</p>
                            {isPaymentSuccess && (
                              <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                ✓ Paid
                              </span>
                            )}
                          </div>
                          <span className={`ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusColor(order.status)}`}>
                            {order.status}
                          </span>
                        </div>
                        <div>
                          <p className="mt-1 text-md text-gray-800 font-medium">
                            {order.other_info?.shipping?.name || order.other_info?.customerName || '—'}
                          </p>
                          {order.other_info?.shopInfo?.shopName && (
                            <p className="text-xs text-emerald-700 font-semibold mt-0.5">
                              🏪 Shop: {order.other_info.shopInfo.shopName}
                            </p>
                          )}
                        </div>
                        <div className="mt-2 flex flex-wrap items-center gap-3 text-md text-gray-600">
                          <span>{order.items?.length ?? 0} items</span>
                          <span className="font-medium">{formatCurrency(order.totalAmount)}</span>
                        </div>
                        <div>
                          <p className="mt-2 text-md text-gray-400">Created: {formatDate(order.createdAt)}</p>
                          <p className="text-xs text-gray-400">Updated: {formatDate(order.updatedAt)}</p>
                        </div>
                      </div>

                      <div className="flex flex-col items-end gap-2">
                        <button
                          onClick={() => handleViewDetails(order)}
                          className="inline-flex items-center px-2 py-1 border border-gray-200 rounded-md text-indigo-600 hover:bg-indigo-50"
                          aria-label={`View details for ${order.razorpay_order_id}`}
                        >
                          <FaEye />
                        </button>

                        <button
                          onClick={() => { setIsPreviewOpen(true); setSelectedOrder(order); }}
                          className="inline-flex items-center px-2 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                          aria-label={`Download invoice for ${order.razorpay_order_id}`}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v12m0 0l4-4m-4 4-4-4M21 21H3" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Enhanced Smart Windowed Pagination */}
        <div className="bg-white border-t border-gray-200 px-4 py-3 sm:px-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div className="flex items-center gap-3 text-sm text-gray-700 flex-wrap">
              <span>
                Showing <span className="font-semibold">{Math.min((pagination.currentPage - 1) * pagination.itemsPerPage + 1, pagination.totalItems || 0)}</span> to{' '}
                <span className="font-semibold">{Math.min(pagination.currentPage * pagination.itemsPerPage, pagination.totalItems || 0)}</span> of{' '}
                <span className="font-semibold">{pagination.totalItems || 0}</span> orders
              </span>
              <span className="text-gray-300 hidden sm:inline">|</span>
              <div className="flex items-center gap-1.5">
                <span className="text-gray-500 text-xs">Per page:</span>
                <select
                  value={pagination.itemsPerPage}
                  onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                  className="rounded-lg border-gray-300 py-1 px-2 text-xs font-medium text-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 bg-gray-50"
                >
                  {pageSizeOptions.map(size => (
                    <option key={size} value={size}>{size}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="flex items-center gap-1.5 flex-wrap">
              <button
                onClick={() => fetchOrders(1)}
                disabled={pagination.currentPage === 1}
                className="px-2.5 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
                title="First Page"
              >
                « First
              </button>
              <button
                onClick={() => fetchOrders(Math.max(1, pagination.currentPage - 1))}
                disabled={pagination.currentPage === 1}
                className="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
              >
                ‹ Prev
              </button>

              <div className="flex items-center gap-1">
                {(() => {
                  const current = pagination.currentPage || 1;
                  const total = pagination.totalPages || 1;
                  let items = [];
                  if (total <= 7) {
                    items = Array.from({ length: total }, (_, i) => i + 1);
                  } else if (current <= 3) {
                    items = [1, 2, 3, 4, '...', total];
                  } else if (current >= total - 2) {
                    items = [1, '...', total - 3, total - 2, total - 1, total];
                  } else {
                    items = [1, '...', current - 1, current, current + 1, '...', total];
                  }

                  return items.map((item, idx) => {
                    if (item === '...') {
                      return (
                        <span key={`dots-${idx}`} className="px-2 py-1 text-gray-400 text-xs select-none">
                          ...
                        </span>
                      );
                    }
                    const isActive = pagination.currentPage === item;
                    return (
                      <button
                        key={item}
                        onClick={() => fetchOrders(item)}
                        className={`min-w-[32px] h-8 rounded-lg text-xs font-semibold transition ${
                          isActive
                            ? 'bg-indigo-600 text-white shadow-sm ring-1 ring-indigo-600'
                            : 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        {item}
                      </button>
                    );
                  });
                })()}
              </div>

              <button
                onClick={() => fetchOrders(Math.min(pagination.totalPages || 1, pagination.currentPage + 1))}
                disabled={pagination.currentPage === pagination.totalPages || pagination.totalPages === 0}
                className="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
              >
                Next ›
              </button>
              <button
                onClick={() => fetchOrders(pagination.totalPages || 1)}
                disabled={pagination.currentPage === pagination.totalPages || pagination.totalPages === 0}
                className="px-2.5 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
                title="Last Page"
              >
                Last »
              </button>
            </div>
          </div>
        </div>
      </div>

      {selectedOrder && (
        <OrderModal
          order={selectedOrder}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onStatusUpdate={handleStatusUpdate}
        />
      )}

      {isEditing  && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
            onClick={() => setIsEditing(false)}
            aria-hidden="true"
          />

          {/* Modal */}
          <div
            role="dialog"
            aria-modal="true"
            className="relative z-10 w-full max-w-lg transform overflow-hidden rounded-2xl bg-white/95 shadow-2xl ring-1 ring-black/5 backdrop-saturate-125 p-6 sm:p-8 transition-all"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              type="button"
              onClick={() => setIsEditing(false)}
              className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white shadow-sm hover:bg-gray-50 text-gray-700"
              aria-label="Close"
              title="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="flex flex-col gap-4">
              <div className="mb-1">
                <h3 className="text-lg font-semibold text-gray-900">Change Order ID</h3>
                <p className="mt-1 text-sm text-gray-500">Provide the old order id, new order id and enter the 6‑digit OTP to confirm.</p>
              </div>

              <div className="grid grid-cols-1 gap-3">
                <label className="flex flex-col">
                  <span className="text-sm font-medium text-gray-700">Old Order ID</span>
                  <input
                    type="text"
                    value={oldOrderId || ''}
                    onChange={(e) => setOldOrderId(e.target.value)}
                    placeholder="eg. ord_ABC123"
                    className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-200"
                  />
                </label>

                <label className="flex flex-col">
                  <span className="text-sm font-medium text-gray-700">New Order ID</span>
                  <input
                    type="text"
                    value={newOrderId || ''}
                    onChange={(e) => setNewOrderId(e.target.value)}
                    placeholder="eg. ord_NEW456"
                    className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-200"
                  />
                </label>

                <div>
                  <span className="text-sm font-medium text-gray-700">OTP (6 digits)</span>
                  <div className="mt-2 flex items-center gap-2">
                    {[0,1,2,3,4,5].map((i) => (
                      <input
                        key={i}
                        ref={(el) => (otpRefs.current[i] = el)}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={1}
                        value={otp[i] ?? ''}
                        onChange={(e) => handleOtpChange(e, i)}
                        onKeyDown={(e) => handleOtpKeyDown(e, i)}
                        className="h-12 w-12 rounded-md border border-gray-200 text-center text-lg font-medium focus:border-indigo-500 focus:ring-1 focus:ring-indigo-200"
                        aria-label={`OTP digit ${i + 1}`}
                      />
                    ))}
                  </div>
                  <p className="mt-2 text-xs text-gray-400">We sent a 6-digit code to your registered number/email.</p>
                </div>
              </div>

              <div className="mt-3 flex items-center justify-between gap-3">
                <button
                  type="button"
                  onClick={() => {
                    // clear inputs and close
                    setOldOrderId('');
                    setNewOrderId('');
                    setOtp(Array(6).fill(''));
                    setIsEditing(false);
                  }}
                  className="inline-flex items-center justify-center rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={async () => {
                    const otpValue = otp.join('');
                    if (!oldOrderId?.trim() || !newOrderId?.trim() || otpValue.length !== 6) {
                      setError('Please fill all fields and enter a 6-digit OTP.');
                      return;
                    }
                    setIsSubmitting(true);
                    setError('');
                    try {
                      // Format data as single object
                      const submitData = {
                        oldRazorpayOrderId: oldOrderId.trim(),
                        newRazorpayOrderId: newOrderId.trim(),
                        otp: otpValue,
                        // timestamp: new Date().toISOString(),
                      };
                      
                      console.log('Submitting order ID change:', submitData);
                      // await apiChangeOrderId(submitData)
                     const response =  await updateRazorpayOrder(selectedOrder.id, submitData, localStorage.getItem('token'));
                      
                     console.log("response", response)// success feedback
                      setSuccess('Order ID updated successfully');
                      setTimeout(() => {
                        setIsSubmitting(false);
                        setIsEditing(false);
                        setSuccess('');
                        setOldOrderId('');
                        setNewOrderId('');
                        setOtp(Array(6).fill(''));
                      }, 800);
                    } catch (e) {
                      setError('Failed to change order id. Please try again.');
                      setIsSubmitting(false);
                    }
                  }}
                  disabled={!oldOrderId?.trim() || !newOrderId?.trim() || otp.filter(digit => digit).length !== 6 || isSubmitting}
                  className={`inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-white ${
                    (!oldOrderId?.trim() || !newOrderId?.trim() || otp.filter(digit => digit).length !== 6 || isSubmitting)
                      ? 'bg-indigo-300 cursor-not-allowed'
                      : 'bg-indigo-600 hover:bg-indigo-700'
                  }`}
                >
                  {isSubmitting ? 'Processing...' : 'Confirm Change'}
                </button>
              </div>

              {(error || success) && (
                <div className={`mt-3 rounded-md p-3 text-sm ${error ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
                  {error || success}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {isPreviewOpen && selectedOrder && (
        <InvoicePreviewModal
          isOpen={isPreviewOpen}
          onClose={() => {
            setIsPreviewOpen(false);
            setSelectedOrder(null);
          }}
          invoiceData={selectedOrder}
          invoiceRef={invoiceRef}
          onDownload={handleDownloadPDF}
        />
      )}
    </div>
  );
};

export default OrdersTable;
